<cc-box>
  <div class="lg-container" box header >{{'LEAD_GENERATION.CREATOR.POPUP.THEME_COLOR' | translate}}</div>
  <div box content>
    <cc-lg-color-bubble-set [control]="popupSettings.controls.theme"></cc-lg-color-bubble-set>
    <div class="lg-container reverse" *ngIf="false">
      <mat-checkbox (change)="reverse($event)"><span >{{'LEAD_GENERATION.CREATOR.POPUP.REVERSE' | translate }}</span>
      </mat-checkbox>
    </div>
  </div>
</cc-box>
